import { useState, useEffect } from "react";
import { getUserId } from "../../../Services/auth";
import faradayApi from "../../../Services/faradayApi";
import { INTERNAL_ROLES } from "../../../utils/Authority";

import fortlevsolarlogo from "../../../Assets/fortlev-solar-logo.png";
import fortlevlogo from "../../../Assets/fortlev-logo.png";
import studioEnergylogo from "../../../Assets/studio-energy-logo.png";
import dsSolarlogo from "../../../Assets/ds-solar-logo.png";
import tecnsyslogo from "../../../Assets/tecnsys-logo.png";
import vanessalogo from "../../../Assets/vanessa-logo.png";

export interface CompanyLogo {
  hasImage: boolean;
  styleType?: string;
  logo?: string;
}

export interface SimulatorUser {
  userEmail: string;
  userCompany: string;
  proposalPermission: boolean;
  internalPartnerPermission: boolean;
  userPermission: boolean;
  companyLogo: CompanyLogo;
}

export function useSimulatorUser(fortlev?: boolean): SimulatorUser {
  const [userEmail, setUserEmail] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [proposalPermission, setProposalPermission] = useState(false);
  const [internalPartnerPermission, setInternalPartnerPermission] = useState(
    false
  );
  const [userPermission, setUserPermission] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const id = getUserId();
      let response: any;

      try {
        response = await faradayApi.get(`users/${id}`);
      } catch (err) {}

      const permissions = response?.data?.permissions?.split(",") ?? [];
      const hasProposalPermission = permissions.includes("proposal");
      const hasInternalPartnerPermission = permissions.includes(
        "internal_partner"
      );

      if (INTERNAL_ROLES.includes(response?.data?.role)) {
        setProposalPermission(true);
        setInternalPartnerPermission(true);
        setUserPermission(true);
      }

      if (hasProposalPermission) {
        setProposalPermission(true);
        setUserPermission(true);
      }

      if (hasInternalPartnerPermission) {
        setInternalPartnerPermission(true);
        setUserPermission(true);
      }

      setUserEmail(response?.data?.email);
      setUserCompany(
        response?.data?.company?.name
          ? response?.data?.company?.name
          : response?.data?.partner_company?.name
      );
    }

    fetchData();
  }, []);

  function getCompanyLogo(): CompanyLogo {
    if (
      (userCompany && userCompany.includes("FORTLEV ENERGIA SOLAR")) ||
      fortlev
    )
      return { hasImage: true, styleType: "FORTLEV", logo: fortlevsolarlogo };

    if (userCompany && userCompany.includes("FORTLEV"))
      return { hasImage: true, styleType: "FORTLEV", logo: fortlevlogo };

    if (userCompany && userCompany.includes("STUDIO ENERGY"))
      return { hasImage: true, styleType: "STUDIO", logo: studioEnergylogo };

    if (userCompany && userCompany.includes("DS ENGENHARIA"))
      return { hasImage: true, styleType: "DS", logo: dsSolarlogo };

    if (userCompany && userCompany.includes("Tecnsys"))
      return { hasImage: true, styleType: "FORTLEV", logo: tecnsyslogo };

    if (userCompany && userCompany.includes("VM PROJETOS"))
      return { hasImage: true, styleType: "STUDIO", logo: vanessalogo };

    return { hasImage: false };
  }

  return {
    userEmail,
    userCompany,
    proposalPermission,
    internalPartnerPermission,
    userPermission,
    companyLogo: getCompanyLogo(),
  };
}
